import { safeParseInt } from '@dte/otw-utils-core/src/numbers/safeParseInt';
import { isBlankValue } from '@dte/otw-utils-core/src/objects/isBlankValue';
import { containsIgnoreCase } from '@dte/otw-utils-core/src/strings/equalsIgnoreCase';

export function isTruthy(value: string | boolean | number | undefined | null): boolean {
	// Treat undefined/null as false
	if (value === undefined || value === null) {
		return false;
	}

	// For boolean values, just return the value as-is
	if (value === true) {
		return true;
	}
	if (value === false) {
		return false;
	}

	// Treat blank values as false
	if (isBlankValue(value)) {
		return false;
	}

	// Treat strings as "true" if they have a value of "true" (case-insensitive)
	if (typeof value === 'string') {
		if (containsIgnoreCase(['true', 't'], value)) {
			return true;
		}
		if (containsIgnoreCase(['false', 'f'], value)) {
			return false;
		}
	}

	// For numbers (or strings we're able to parse as numbers), consider as "true" if greater than 0
	const numericValue = safeParseInt(value);
	if (!numericValue) {
		return false;
	}
	return numericValue > 0;
}
